module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group group--sidebar group--df-column"
  }, [_c('div', {
    staticClass: "group group--df group--wide"
  }, [_c('div', [_c('h1', {
    staticClass: "h1 group__title mb0",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("Verification Password")]), _vm._v(" "), _c('p', {
    staticClass: "p group__description"
  }, [_vm._v("\n        We have sent a verification code to " + _vm._s(_vm.user.email) + ". Please enter the code below to verify your account.")]), _vm._v(" "), _c('transition-expand-height', [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resendErrorMessage),
      expression: "resendErrorMessage"
    }],
    staticClass: "c-error"
  }, [_vm._v(_vm._s(_vm.resendErrorMessage))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.resendErrorMessage && _vm.resendVerificationResponse),
      expression: "!resendErrorMessage && resendVerificationResponse"
    }],
    staticClass: "p"
  }, [_vm._v(_vm._s(_vm.resendVerificationResponse))])]), _vm._v(" "), _c('ui-auth', {
    staticClass: "pab2",
    attrs: {
      "id": "verify",
      "success": _vm.success,
      "send-verification": _vm.resendVerification,
      "verify-text": _vm.resendEmailCodeText
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2219b7fc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/auth/RegisterVerification.vue
// module id = 485
// module chunks = 0